import { render, staticRenderFns } from "./ControlSocial.vue?vue&type=template&id=3c855bad"
import script from "./ControlSocial.vue?vue&type=script&lang=js"
export * from "./ControlSocial.vue?vue&type=script&lang=js"
import style0 from "./ControlSocial.vue?vue&type=style&index=0&id=3c855bad&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports